import { temAcesso } from '@/bibliotecas/seguranca/authLib'
import carteirasRotas from './carteiras/CarteiraRotas'
import recebimentosRotas from './recebimentos/RecebimentosRotas'
import devolvidosRotas from './devolvidos/DevolvidosRotas'
import painelRotas from './painel/PainelRotas'
import parcelasRotas from './parcelas/ParcelasRotas'
import devedoresRotas from './devedores/DevedoresRotas'

export default {
    path: 'credores',
    name: 'Credores',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (to.name === 'Credores') {
            if (temAcesso('CRED-00')) {
                next()
            }
        } else {
            next()
        }
    },
    children: [
        carteirasRotas,
        recebimentosRotas,
        devolvidosRotas,
        painelRotas,
        parcelasRotas,
        devedoresRotas
    ]
}



// WEBPACK FOOTER //
// ./src/modulos/credores/CredoresRotas.js